import type { Router } from '@tanstack/react-router';

import { init } from '#core/main';

import { config } from '#config';
import { routeTree } from '#routeTree.gen';

import { AppProvider } from '#contexts/AppProvider';

init(routeTree, config, AppProvider);

declare module '@tanstack/react-router' {
  interface Register {
    router: Router<typeof routeTree>;
  }
}

type ConfigType = typeof config;

declare module '#core/schema/ProjectConfigSchema' {
  interface ProjectConfigOverrides extends ConfigType {}
}
